import { render } from "./ToastComp.vue?vue&type=template&id=28a7a58f&scoped=true"
import script from "./ToastComp.vue?vue&type=script&lang=js"
export * from "./ToastComp.vue?vue&type=script&lang=js"

import "./ToastComp.vue?vue&type=style&index=0&id=28a7a58f&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a7a58f"]])

export default __exports__